// exportLabs.ts
import ExcelJS from 'exceljs'
import { saveAs } from 'file-saver'
import moment from 'moment'

export interface LabRow {
    treatmentPlanTypeName: string
    treatmentPlanTypeNameEn: string
    status: string
    updatedBy: string
    updatedAt: string
}

export interface PlanTypeReport {
    title: string
    statusFilter: string
    rows: LabRow[]
    t: any
}

export async function exportPlanTypeToExcel(report: PlanTypeReport) {
    const wb = new ExcelJS.Workbook()
    const ws = wb.addWorksheet(report.title, {
        pageSetup: { orientation: 'portrait' }
    })
    ws.properties.defaultRowHeight = 20

    ws.columns = [
        { header: '#', width: 6 },
        { header: report.t('TREATMENT_PLAN_TYPE.TABLE.CELL.TREATMENT_PLAN_TYPE_NAME'), width: 30 },
        { header: report.t('TREATMENT_PLAN_TYPE.TABLE.CELL.TREATMENT_PLAN_TYPE_NAME_EN'), width: 30 },
        { header: report.t('TREATMENT_PLAN_TYPE.TABLE.CELL.STATUS'), width: 14 },
        { header: report.t('TREATMENT_PLAN_TYPE.TABLE.CELL.UPDATED_BY'), width: 30 }
    ]

    let row = 1

    ws.mergeCells(row, 1, row, 5)
    ws.getCell(row, 1).value = report.title
    ws.getCell(row, 1).font = { size: 16, bold: true }
    ws.getCell(row, 1).alignment = { horizontal: 'center', vertical: 'middle' }
    row += 2

    ws.mergeCells(row, 1, row, 5)
    ws.getCell(row, 1).value = report.statusFilter
    ws.getCell(row, 1).font = { size: 12 }
    ws.getCell(row, 1).alignment = { horizontal: 'left', vertical: 'middle' }
    row += 2

    const headerRow = ws.addRow(ws.columns.map(col => col.header as string))
    headerRow.height = 24
    headerRow.font = { bold: true }
    headerRow.alignment = { horizontal: 'center', vertical: 'middle' }
    headerRow.eachCell(cell => {
        cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFFFFFFF' }
        }
        cell.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' }
        }
    })
    row++
    if (!report.rows || report.rows.length === 0) {
        const noDataRow = ws.addRow([report.t('REPORT.TITLE.NO_DATA')])
        ws.mergeCells(noDataRow.number, 1, noDataRow.number, ws.columns.length)
        noDataRow.font = { italic: true, color: { argb: 'FF000000' } }
        noDataRow.alignment = { horizontal: 'center' }
        const buf = await wb.xlsx.writeBuffer()
        saveAs(
            new Blob([buf]),
            `${report.title}_${moment().format('YYYYMMDD')}.xlsx`
        )
        return
    }
    // 5) Data rows
    report.rows.forEach((r, i) => {
        const excelRow = ws.addRow([
            i + 1,
            r.treatmentPlanTypeName,
            r.treatmentPlanTypeNameEn,
            r.status,
            `${r.updatedBy} ${r.updatedAt}`
        ])
        excelRow.height = 20
        excelRow.eachCell((cell, col) => {
            // border รอบทุก cell
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
            }
            switch (col) {
                case 2:
                case 3:
                    cell.alignment = { horizontal: 'left', vertical: 'middle' }
                    break
                default:
                    cell.alignment = { horizontal: 'center', vertical: 'middle' }
            }
        })
    })

    const buf = await wb.xlsx.writeBuffer()
    saveAs(
        new Blob([buf]),
        `${report.title}_${moment().format('YYYYMMDD')}.xlsx`
    )
}
